import React from 'react';
import styled from 'styled-components';



/*

Props:


*/

const StyledForm = styled.form`
  display: flex;
  flex-direction: ${props => props.flexDirection ? props.flexDirection : 'row'};
  /* flex: 1; */
  ${props => props.height ? 'height:' + props.height+'px;' : ''}
  ${props => props.minHeight ? 'min-height:' + props.minHeight+'px;' : ''}
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #e0e0e0c7;
  background-color: white;
  padding-top: 5px;
  padding: 5px 0px 5px 0px;
  width: 100%;
  /* width: ${props => props.width ? props.width : '200'}px; */
  /* max-width: ${props => props.maxWidth ? props.maxWidth : '200'}px; */
  /* position: absolute;
  bottom: 0px; */
  `;
  //  box-sizing: border-box;
   
const MessageSubmitFormSC = ({ styles, children, onSubmit, ...rest }) => (
  <StyledForm style = {styles} onSubmit = {onSubmit} {...rest} >
      { children }
  </StyledForm>
)

export default MessageSubmitFormSC





// WEBPACK FOOTER //
// ./src/js/components/Chat/MessageSubmitFormSC.jsx